module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAIAAAAPTiitAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAATSURBVChTY/hPBBhVRDVF//8DADR3ZqhNJJ9OAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/logo-sidebar.png
// module id = 547
// module chunks = 0